import { config } from '../config';

async function client(
  endpoint,
  { body, method, ...customConfig } = {},
  baseUrl = config.API_BASE_URL
) {
  const headers = { 'content-type': 'application/json' };

  const apiConfig = {
    method: method || 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    apiConfig.body = JSON.stringify(body);
  }

  return fetch(`${baseUrl}${endpoint}`, apiConfig).then(async (r) => {
    const data = await r.json();
    if (r.ok) {
      return data;
    } else {
      return Promise.reject(data);
    }
  });
}

export default { client };
